export default {
  PERSONAL: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  HOME: [
    "",
    "",
    "",
    "",
    "", //5
    "",
    "",
    "",
    "",
    "", //10
    "",
    "新燕宝2022", //-
    "少儿专属单独投保",
    "门诊无等待期",
    "中间带金牌认证医生", //15
    "24小时健管团队",
    "免现金刷卡直付",
    "门急诊住院全面涵盖",
    "臻荣耀2022个人全球医疗保险",
    "免现金刷卡直付", //20
    "中/高端方案自由选择",
    "全面医疗保障",
    "亲子计划灵活搭配",
    "",
    "", //25
    "",
    "",
    "",
    "",
    "", //30
    "",
    "",
    "",
    "",
    "", //35
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  about: [
    "",
    "",
    "",
    "",
    "", // 5
    "",
    "",
    ``,
    "",
    "", // 10
    "",
    "",
    "",
    "",
    "关于我们", // 15
    "新闻中心",
    "企业视频",
    "",
    "",
    "", // 20
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  thirdPartService: [
    "",
    "",
    "",
    "",
    "", // 5
    "在线就诊前身份确认在线就诊后理赔数据捕捉和确认",
    "理赔付款处理<br />含直接付款服务",
    "医疗机构担保<br />付费的行政处理",
    "住院跟踪及<br />出院前医疗费用审查",
    "未核准诊断确认沟通<br />理赔申请文档收集", // 10
    "",
    "在线实时身份验证",
    "安全、可靠、保密、并已经得到认证的技术。",
    "省时高效的实时报表系统",
    "简便的注册方式和无纸化管理", // 15
    "先进的，安全可信的电子医疗卡网络",
    "范围广、数量多的网络医疗机构",
    "拥有跨区域的理赔经验，提供专业的风险管控。",
    "",
    "", // 20
    "",
    "",
    "",
    "",
    "", // 25
    "电子实时在线的身份确认和福利确认",
    "灵活、通用并且高度可定制化",
    "通过最新型最优良的应用程序和技术提供最高标准的服务",
    "安全可信赖的电子医疗网络",
    "", // 30
    "",
    `齿科诊所`,
    "药店",
    "检查室",
    "诊所", // 35
    "医院",
    "医疗管理组织",
    "保险公司",
    "公估公司",
    "企业团体", // 40
    "第三方管理机构",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  about1: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  videoCenter: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  PAS: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ``,
    "",
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  PAS1: [
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  PAS2: [
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  PAS3: [
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  TCMN: [
    "",
    "",
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  SOS: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  BFM: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  BFM1: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  EMA: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  IC: [
    "",
    "",
    "",
    "",
    "",
    ``, //5
    "",
    "",
    "",
    "",
    "", //10
    ``,
    "",
    "",
    "",
    "", //15
    "",
    ``,
    "",
    "",
    "", //20
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  FAQ: [
    "",
    "",
    "",
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    ``,
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  LOGIN: [
    "",
    "",
    "",
    "",
    "总部地址：北京市朝阳区建国门外大街丙24号，京泰大厦10层", // 5
    "联系方式：",
    "邮编：",
    "传真：",
    "网址：",
    "", // 10
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  AMG: [
    "",
    "",
    "",
    "",
    "",
    "",
    "", // 6
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  ML: [
    "",
    "",
    "",
    "",
    "", // 5
    "",
    "",
    "",
    "",
    "", // 10
    "",
    "",
    "",
    "",
    "", // 15
    "",
    "",
    "",
    "",
    "", // 20
    "",
    "",
    "",
    "",
    "", // 25
    "",
    "",
    "",
    "",
    "", // 30
    "",
    "",
    "",
    "",
    "", // 35
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  ML1: [
    "",
    "",
    "",
    "",
    "", // 5
    "",
    "",
    "",
    "",
    "", // 10
    "",
    "",
    "",
    "",
    "", // 15
    "",
    "",
    "",
    "",
    "", // 20
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "", // 请选择国家
    "", // 请选择州、省
    "", // 请选择市
    "", // 请选择国家或州/省
  ],
  JOIN: [
    "",
    "网上填写申请表",
    "中间带网络部将与您联系",
    "经过评估由网络部主管最终审核",
    "合作意见邮件反馈", // 5
    "如达成合作意向线下签订合约",
    "",
    "",
    "",
    "", // 10
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  OVERSEAS: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  distanceList: [
    "5km以内",
    "10km以内",
    "15km以内",
    "20km以内",
    "30km以内",
    "30km以上",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  vipServiceLogin: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  vipServiceContent: [
    "",
    "",
    "",
    "",
    "",
    "",
    /*5 */
    "",
    "",
    "",
    "",
    "",
    /**10 */
    "",
    "",
    "",
    "",
    "", //15
    "",
    "",
    "",
    "",
    "", //20
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  hospitals: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  specialServiceTab: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  specialServiceContent: [
    "",
    "",
    "",
    "",
    "",
    "",
    /*5*/
    "",
    "",
    "",
    "",
    "",
    /*10*/
    "",
    "",
    "",
    "",
    "",
    /*15*/
    "",
    "",
    "",
    "",
    /**20 */
    "",
    "",
    "",
    "",
    "",
    /* 25*/
    "",
    "",
    "",
    "",
    "",
    /*30*/
    "",
    "",
    "",
    "",
    "",  //35
    "",
    "",
    "",
    "",
    "", //40
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  emergencyContent: [
    "",
    "",
    "",
    //我们的服务
    "",
    "",
    /*5*/ "",
    "",
    "",
    "",
    "",
    // 我们如何工作的
    /*10*/ "",
    "",
    "",
    "",
    "",
    // 会员福利
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  // 医疗服务
  medicalservices: [
    "",
    "",
    "",
    "",
    "医生1，护士≥1", //5
    "＞100平方米",
    "有医疗机构资质",
    "一般看诊及处置，药品发放",
    "应急保障及增值健康服务",
    "", //10 健康中心
    "", //医务室
    "", //健康小屋
    "医生1，护士可选",
    "无医疗机构资质",
    "一般诊疗咨询建议", //15
    "应急保障及增值健康服务",
    "多医多护+管理人员",
    "急救转运车辆",
    "＞500平方米",
    "有医疗机构资质", //20
    "一般看诊及处置，药品发放",
    "应急体系搭建及增值健康服务",
    "",
    "基础服务",
    "项目筹建/资质办理", //25
    "日常诊疗/应急保障",
    "智能医疗",
    "ERP系统/HIS系统",
    "线上问诊/智能配套",
    "健康管理", //30
    "慢病管理/职业健康",
    "理疗服务/专案服务",
    "医疗合作",
    "专科坐诊/健康讲座",
    "健康活动/绿通服务", //35
    "",
    "",
    "",
    "",
    "", //40
    "",
    "",
    "",
    "",
    "", //45
    "数据收集",
    "体检报告数据",
    "日常看诊数据",
    "个人健康数据",
    "高位筛查", //50
    "高危因素分析",
    "健康量表测算",
    "补充专科检查",
    "精准定位对象",
    "医生健康宣教", //55
    "健康管理",
    "建立健康档案",
    "专业用药建议",
    "膳食运动处方",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  // 企业健康管理方案
  healthPlan: [
    "", //企业健康管理方案
    "",
    "",
    "",
    "价格灵活", //5
    "可以满足不同客户预算",
    "一站式解决方案",
    "一站式全程服务，解决企业客户痛点需求",
    "丰富医生资源",
    "为企业健康管理服务提供优质的医疗支持", //10
    "技术系统优势",
    "高效顺畅，以领先数字化服务做支撑",
    "",
    "一带一路“企业：某大型石油公司",
    "该公司自2020年10月成为中间带高端医疗客户，是中间带自营业务运营以来首个会员人数超300人的客户。客户因项目性质，需频繁去伊拉克、迪拜等地区工作，另有加拿大、摩洛哥等地均有员工及家属分布，对此中间带在一周之内迅", //15
    "",
    "中外合资企业：某大型集成电路制造股份有限公司",
    "该公司自2021年7月成为中间带高端医疗客户，保障计划涵盖门诊，住院，生育，增值服务等内容，中间带为该公司提供了四组计划套餐和多样的可选额度，满足客户的计划分层。为满足客户就近就诊需求，中间带与该公司职场附近",
    "A股上市公司：某大型医药科技股份有限公司",
    "公司2021年3月成为中间带高端医疗客户。面对公司高管频繁外派于香港、新加坡、和澳大利亚工作的情况，中间带为客户提供了一款包含…", //20
    "大型互联网公司：某大型互联网公司",
    "公司于2021年6月成为中间带高端医疗保险客户。该公司作为国内前端的旅游业服务公司之一，为其团队配置了极佳的员工福利，正…",
    "A股上市公司：某跨国国际人力资源股份有限公司",
    "外资企业：某跨国外企公司",
    "公司于2020年11月成为中间带高端医疗保险客户。中间带为北京、上海、苏州等地的公司高管提供健康保险服务，涉及住院、门诊、牙科…", //25
    "公司于2020年11月成为中间带高端医疗保险客户。中间带为其提供包括住院、门诊、生育、体检、视力、齿科、精神卫生及旅游安全等全…",
    "",
    "",
    "",
    "", //30
    "",
    "",
    "",
    "",
    "", //35
    "",
    "",
    "",
    "",
    "", //40
    "",
    "",
    "",
    "",
    "", //45
    "",
    "",
    "",
    "",
    "", //50
    "",
    "",
    "",
    "",
    "", //55
    "",
    "",
    "",
    "",
    "", //60
    "该公司自2020年10月成为中间带高端医疗客户，是中间带自营业务运营以来首个会员人数超300人的客户。客户因项目性质，需频繁去伊拉克、迪拜等地区工作，另有加拿大、摩洛哥等地均有员工及家属分布，对此中间带在一周之内迅速完成伊拉克地区保险服务落地，并对中东地区跨国转账受限事宜作出对策，确保了国内外员工就诊的无缝衔接。",
    "中间带还为该公司项目成立了专项服务组，确保在紧急情况下各部门之间均能迅速对接。在服务过程中，我们为客户逐步优化服务体系，完善并上线了慢病送药、大病跟踪关怀、实时线上理赔报告等功能，为客户个人、企业对接人提供更多人性化关怀服务。",
    "该公司自2021年7月成为中间带高端医疗客户，保障计划涵盖门诊，住院，生育，增值服务等内容，中间带为该公司提供了四组计划套餐和多样的可选额度，满足客户的计划分层。为满足客户就近就诊需求，中间带与该公司职场附近的医疗资源、环境、服务优质的公立医院达成合作，纳入“直付医疗网络”。这一举动收到了客户的好评。",
    "中间带自2005年进入中国市场，生根本地化医疗网络拓展，当前绝大多数公立医院VIP部、特需部或国际部均已进入中间带“直付医疗网络”，很多私立医疗机构也通过了中间带的资质和综合服务能力审核，成为了中间带直付医院。中间带高端医疗产品的会员持身份证件与高端医疗会员卡，便可在网络医院中享受便捷的“直付服务”，免去个人收集材料、递交保险公司的流程。",
    "公司2021年3月成为中间带高端医疗客户。面对公司高管频繁外派于香港、新加坡、和澳大利亚工作的情况，中间带为客户提供了一款包含住院、门诊等福利的全球除美计划。为方便身处国外的客户更方便地联系到中间带国内客服中心，中间带在上述三个国家和地区开通了本地热线功能，使得该客户无需开通国际长途，便能通过本地热线顺利转接到中间带国内客服中心，进一步方便客户使用保险各项服务。中间带除为其开通了便捷的微信公众号平台外，还进一步满足客户需求，在中间带PC端官方网站上，增加了绑卡和服务申请功能，会员可通过网站登录平台，获得丰富的保险服务。", //65
    "公司于2021年6月成为中间带高端医疗保险客户。该公司作为国内前端旅游业服务公司之一，为其团队配置了极佳的员工福利，正式成为该团体高端医疗服务供应商后，中间带在该团体的计划中，设计涵盖了住院、门诊、生育、牙科、体检等各项福利。在2021年入保期间，中间带配合该公司现有员工团检供应商进行了合作衔接，打通了保险理赔款代付员工体检款通道，这一合作不但进一步节约了客户的人事管理成本，也为客户提供了更完善的员工健康管理体系。相较于传统高端医疗服务供应商，中间带更愿意迎接创新且具有挑战性的业务合作模式，用以满足客户多样化需求。通过与体检机构合作的业务，中间带进一步加强了企业级健康管理的业务能力。",
    "公司于2020年11月成为中间带高端医疗保险客户。中间带为北京、上海、苏州等地的公司高管提供健康保险服务，涉及住院、门诊、牙科等高端医疗保障。中间带强大的医疗网络和扩网效率满足了公司高管在全国出差过程中对优质医疗资源和贴心服务的需求。在2021年度的服务中，该客户曾与一家私立齿科机构产生摩擦与财务纠纷，中间带客户经理了解情况后积极参与沟通与协调，最终在各方努力下为客户争取到利益最大化，用户对中间带的工作表示认可与感谢。",
    "中间带注重维护客户利益，在业务发展过程中，中间带一直以协同与支持的姿态为客户各方面利益保驾护航。",
    "公司于2020年11月成为中间带高端医疗保险客户。中间带为其提供包括住院、门诊、生育、体检、视力、齿科、精神卫生及旅游安全等全方位一站式健康管理咨询与保障服务。在服务过程中，中间带各部门工作人员全力以赴，保障公司的中外籍员工都能顺利使用各项保险服务与增值服务，并与客户建立了良好紧密的协助关系。在2021年的服务过程中，该公司一位外籍员工在公立医院就诊时，不慎遗失就诊材料，难以集齐递交理赔。中间带客户经理获悉情况后，主动与该客户进行积极沟通，并协调中间带医疗网络团队参与协助。最后中间带在得到客户同意下，委派代表同事借用会员医院就诊卡，前往医院代客户补开医疗材料，后将就诊卡归还客户本人。",
    "在本次服务过程中，中间带处于为客户提供最大便利的角度，全力协助客户。在各方的努力与沟通下，会员顺利获得全额理赔，并表扬中间带为他提供了“完美的服务”。", //70
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  // 中间带杏带
  yixing: [
    ""
  ],
  //新燕宝
  productDetails: [
    "",
    "",
    "",
    "",
    "", //5
    "",
    "",
    "",
    "",
    "", //10
    "",
    "",
    "",
    "",
    "", //15
    "",
    "",
    "",
    "",
    "", //20
    "",
    "",
    "",
    "", //25
    "",
    ``, //27
    ``, //28
    //问答
    "",
    "", //30
    "",
    "",
    "",
    "",
    "", //35
    "",
    "",
    "",
    "",
    "", //40
    "",
    "",
    "",
    "",
    "", //45
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
  ],
  xinyanbaoxuzhi: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  fuyanbaoxuzhi: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  xiaoyanbaoxuzhi: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  options: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  zhenrongyao: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  fuyanbao: [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  // 顶部菜单
  header: [
    "",
    "",
    "",
    "",
    "", //5
    "",
    "",
    "",
    "",
    "", //10
    "",
    "",
    "",
    "",
    "", //15
    "",
    "",
    "",
    "",
    "", //20
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
};
